export default __webpack_public_path__ + "static/media/loading-icon.3937d8d8.svg";